import { ILogistics } from './logistics';

export interface ILogisticsResponse {
    data: {
        success: boolean;
        results: ILogistics;
    }
}
